import { useEffect, useState } from 'react';
import { getDreamBotRuntimeConfig } from './runtimeConfig';

interface DreamBotIconProps {
  size?: number;
  className?: string;
}

export function DreamBotIcon({ size = 16, className = '' }: DreamBotIconProps) {
  const config = getDreamBotRuntimeConfig();
  const assetsBaseUrl = config.assetsBaseUrl || '';
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const { mountId } = getDreamBotRuntimeConfig();
    const id = mountId && typeof mountId === 'string' ? mountId : 'dreambot-widget-root';
    const el = document.getElementById(id);
    const checkDark = () => {
      setIsDark(!!el?.classList.contains('dark'));
    };
    
    checkDark();
    
    const observer = new MutationObserver(checkDark);
    if (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    }
    
    return () => observer.disconnect();
  }, []);
  
  return (
    <img
      src={(assetsBaseUrl
        ? `${assetsBaseUrl}/${isDark ? 'dreambotwhite' : 'dreambotblack'}.png`
        : `/wp-content/plugins/dreambot/assets/${isDark ? 'dreambotwhite' : 'dreambotblack'}.png`
      )}
      alt="DreamBot"
      width={size}
      height={size}
      className={className}
    />
  );
}
